import { SiafLiteApiRepository } from "../../external";
import store from "../../config/store";

class OrdemServicoService {
  constructor() {
    this.urlBase = "faturamento/ordem-servicos";
    this.urlBaseEvent = `/event/${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  reabrir(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/reabrir/${id}`,
    );
  }

  cancelar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/cancelar/${id}`,
    );
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  atualizarStatus(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/update-status`).put(
      id,
      body,
    );
  }

  getOS(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/ordem-servico`,
    ).patch(body);
  }

  getTermoAceiteChecklist(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/termo-aceite-checklist`,
    ).patch(body);
  }

  getModeloRecibo80mm(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/recibo`).patch(body);
  }
}

export default OrdemServicoService;
